import React from 'react'
import ModalFactContentContainer from '../ModalFactContentContainer'
import ScrollBar from 'react-scrollbar'
import classNames from 'classnames'

class ModalFactWrapper extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      refresh: 0
    }

    this.handlers = {
      refreshScrollArea: this.refreshScrollArea.bind(this)
    }
  }

  refreshScrollArea() {
    this.setState({
      refresh: Math.random()
    })

    this.forceUpdate()
  }

  render() {
    let quiz = this.props.data.quiz
    let {isProtectQuiz} = this.props

    const checkingFileExistence = (id) => {
      try {
        return require('../../assets/images/facts/' + id + '/main.png')
      } catch (err) {
        return null
      }
    }

    return (
      <div className={classNames('fact-wrapper', {'without-image' : !checkingFileExistence(this.props.data.id)})}>
        {
          this.props.windowWidth >= 1024 ?
            <ScrollBar className={classNames({'indented-right' : this.props.data.background})} refresh={this.state.refresh}>
              <ModalFactContentContainer
                {...this.handlers}
                {...this.props}
                {...this.state}
                quiz={quiz}
              />
            </ScrollBar>
            :
            <ModalFactContentContainer
              {...this.handlers}
              {...this.props}
              {...this.state}
              quiz={quiz}
            />
        }
        {
          checkingFileExistence(this.props.data.id) ? (
            isProtectQuiz ? '' :
              <div className="image">
                <div className="image-background"
                     style={{backgroundImage: 'url(' + require(`../../assets/images/facts/${this.props.data.id}/main.png`) + ')'}}
                />
                {
                  this.props.data.background && this.props.windowWidth >= 1024 ? (
                  this.props.isIE11 ? '' :
                    <svg viewBox="0 0 74 870" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 868V0H74L0 868Z" fill={quiz ? "#070236" : "white"}/>
                    </svg>) : ''
                }
              </div>
            ) : ''
        }
      </div>
    );
  }
}

export default ModalFactWrapper
